import { mpx } from "@didi/es-mpx-creator";
import { GET_HOMEPAGE_DATA, GET_HOMEPAGE_ORDER_LIST } from "@/api/urls";

/**
 * @method 获取首页信息
 * @param params
 * @returns {Promise}
 */
export const requestHomePageApi = (data) => {
  return mpx.$http.post(GET_HOMEPAGE_DATA, { data });
};

/**
 * @method 获取首页行程信息
 * @param params
 * @returns {Promise}
 */
export const requestHomeOrderListApi = (data) => {
  return mpx.$http.post(GET_HOMEPAGE_ORDER_LIST, { data })
};
